import React from 'react'
import Link from 'gatsby-link'
import {ThemeProvider} from 'styled-components'

import Offline from 'react-icons/lib/md/cloud-off'
import Signal from 'react-icons/lib/md/settings-input-antenna'
import Devices from 'react-icons/lib/md/phonelink'
import Arrow from 'react-icons/lib/md/keyboard-arrow-right'

import Header from '../components/header'
import Feature from '../components/feature'
import Button from '../components/button'
import Dienstplan from '../components/dienstplan'

import Image from '../static/calendar-sync.svg'

const DienstPlanPage = () => (
  <ThemeProvider
    theme={{
      color: '#a35bff'
    }}
  >
    <div>
      <Header
        title="Dienstplan Sync"
        phrase="Dein Dienstplan, immer aktuell in deinem Kalender"
        image={{
          src: Image
        }}
      >
        Deine Dienstzeiten sind ein fester Bestandteil deines Tags – deshalb
        dürfen sie auch in deinem Kalender nicht fehlen.
      </Header>
      <Dienstplan />
      <Feature title="Immer aktuell" icon={<Signal />}>
        Dein Kalender aktualisiert sich automatisch im Hintergrund. Nie wieder
        warten bis die App geladen hat.
      </Feature>
      <Feature title="Auf all deinen Geräten" icon={<Devices />}>
        Egal ob iOS, Android oder PC – solange deine Kalender App
        „Kalenderabonnements“ unterstützt, kannst du deinen Dienstplan damit
        synchronisieren. Deine Dienstzeiten über Siri, auf deiner Smartwatch
        oder als Widget – all das ist jetzt möglich.
      </Feature>
      <Feature title="Kein Internet? Kein Problem!" icon={<Offline />}>
        Deine Dienste werden automatisch auf deinem Gerät gespeichert, deshalb
        kannst du sie auch offline einsehen. Das ist praktisch, wenn du gerade
        kein Internet hast bzw. die RK Server wieder einmal nicht erreichbar
        sind.
      </Feature>
    </div>
  </ThemeProvider>
)

export default DienstPlanPage



// WEBPACK FOOTER //
// ./src/pages/dienstplan.js